// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningDashedCircleBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M14.5 3.967A1.5 1.5 0 0 1 16 2.5c.403 0 .802.018 1.197.052C24.093 3.16 29.5 8.947 29.5 16c0 1.299-.184 2.557-.528 3.75a1.5 1.5 0 1 1-2.882-.832c.267-.925.41-1.903.41-2.918 0-5.473-4.189-9.97-9.534-10.456l-1.032-.045A1.5 1.5 0 0 1 14.5 3.967ZM12.54 6.083a1.5 1.5 0 1 0-.988-2.833 13.457 13.457 0 0 0-3.018 1.5 1.5 1.5 0 0 0 1.66 2.5 10.457 10.457 0 0 1 2.346-1.167ZM7.687 9.584A1.5 1.5 0 0 0 5.314 7.75 13.448 13.448 0 0 0 2.5 16c0 .506.028 1.006.082 1.498a1.5 1.5 0 1 0 2.982-.33A10.63 10.63 0 0 1 5.5 16c0-2.418.816-4.641 2.187-6.416ZM4.292 20.678a1.5 1.5 0 0 1 2.03.613 10.539 10.539 0 0 0 5.762 4.952 1.5 1.5 0 1 1-1 2.829 13.54 13.54 0 0 1-7.406-6.363 1.5 1.5 0 0 1 .614-2.031ZM26.5 24.487a1.5 1.5 0 1 0-2.333-1.887A10.477 10.477 0 0 1 16 26.5a1.5 1.5 0 0 0 0 3c4.241 0 8.027-1.958 10.5-5.013Z"
					/>
					<path
						fill="currentColor"
						d="M23.06 13.727a1.5 1.5 0 0 0-2.12-2.121L18 14.546l-1.606-1.607a1.5 1.5 0 0 0-2.121 0l-5.334 5.334a1.5 1.5 0 1 0 2.122 2.121l4.272-4.273 1.606 1.606a1.5 1.5 0 0 0 2.122 0l4-4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
